/**
 * Surlignage des questions dans le chat (WELYA-382).
 *
 * Depuis la fusion des onglets Chat et Questions, une question en attente ne quitte plus le chat :
 * elle y reste et se distingue par un fond jaune, réservé aux présentateurs et modérateurs.
 */

/** Token « Warning Full » du design system. */
export const QUESTION_HIGHLIGHT_BACKGROUND = '#FFD753';

export type QuestionHighlightInput = {
  /** Vue présentateur/modérateur. Un spectateur ne voit jamais le surlignage. */
  isStaffView: boolean;
  question?: boolean;
  questionHandled?: boolean;
  reaction?: boolean;
  /** Confirmation de blocage en cours : la bulle porte déjà son propre fond rouge. */
  blocking?: boolean;
  /** Auteur bloqué : idem, fond rouge prioritaire. */
  banned?: boolean;
};

export function shouldHighlightQuestion({
  isStaffView,
  question,
  questionHandled,
  reaction,
  blocking,
  banned,
}: QuestionHighlightInput): boolean {
  if (!isStaffView) return false;
  if (question !== true) return false;
  if (questionHandled === true) return false;
  if (reaction === true) return false;
  if (blocking === true || banned === true) return false;
  return true;
}
